const SportsLabel = Object.freeze({
  soccer: 'Integrations_Sportradar_Label_Soccer',
  nba: 'Integrations_Sportradar_Label_Nba',
  nfl: 'Integrations_Sportradar_Label_Nfl',
  mlb: 'Integrations_Sportradar_Label_Mlb',
  nhl: 'Integrations_Sportradar_Label_Nhl'
})

export { SportsLabel }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportradar/enum/SportsLabelEnum.js